import Logo from './logo.svg'
import ZwillingLogo from './zwilling.svg'

import LogoFull from './logo-full.svg'

const currentTheme = process.env.REACT_APP_SKIN_CUSTOMIZATION
const currentVersion = process.env.REACT_APP_VERSION || ''

const themes = {
  cuciniale: {
    logo: Logo,
    logoFull: LogoFull,
    title: `Web Editor ${currentVersion}`,
    loadingAniation: `
    @keyframes loading-animation {
      0% {
        transform: rotate(-30deg);
      }
      33% {
        transform: rotate(0deg);
      }
      66% {
        transform: rotate(30deg);
      }
      100% {
        transform: rotate(-30deg);
      }
    }`,
  },
  zwilling: {
    logo: ZwillingLogo,
    logoFull: ZwillingLogo,
    title: `Web Editor ${currentVersion}`,
    loadingAniation: `
    @keyframes loading-animation {
      0% {
        transform: scale(0.8);
      }
      50% {
        transform: scale(1);
      }
      100% {
        transform: scale(0.8);
      }
    }`,
  },
}

export const getTheme = () => currentTheme ? themes[currentTheme] || themes.cuciniale : themes.cuciniale

export default themes
